export const INSTRUMENT_TYPES = {
  original: "original",
  rebalanced: "rebalanced",
  comparison: "comparison",
  optimized: "optimized",
  delta: "delta",
  target: "target",
  start: "start",
  end: "end",
} as const
export type InstrumentTypes = (typeof INSTRUMENT_TYPES)[keyof typeof INSTRUMENT_TYPES]

export const SELECTED_MODE_VALUES = {
  original: INSTRUMENT_TYPES.original,
  rebalanced: INSTRUMENT_TYPES.rebalanced,
  comparison: INSTRUMENT_TYPES.comparison,
  start: INSTRUMENT_TYPES.start,
  end: INSTRUMENT_TYPES.end,
  optimized: INSTRUMENT_TYPES.optimized,
  rebalancedVsOriginal: "rebalancedVsOriginal",
  rebalancedVsComparison: "rebalancedVsComparison",
  originalVsComparison: "originalVsComparison",
  optimizedVsOriginal: "optimizedVsOriginal",
  optimizedVsRebalanced: "optimizedVsRebalanced",
  endVsStart: "endVsStart",
  rebalancedVsEnd: "rebalancedVsEnd",
  rebalancedVsStart: "rebalancedVsStart",
} as const
export type SelectedMode = (typeof SELECTED_MODE_VALUES)[keyof typeof SELECTED_MODE_VALUES]

export const REBALANCED_MODES = [
  SELECTED_MODE_VALUES.rebalanced,
  SELECTED_MODE_VALUES.rebalancedVsOriginal,
  SELECTED_MODE_VALUES.rebalancedVsComparison,
  SELECTED_MODE_VALUES.optimizedVsRebalanced,
] as const

export const COMPARISON_MODES = [
  SELECTED_MODE_VALUES.originalVsComparison,
  SELECTED_MODE_VALUES.rebalancedVsComparison,
  SELECTED_MODE_VALUES.comparison,
  SELECTED_MODE_VALUES.optimized,
  SELECTED_MODE_VALUES.optimizedVsOriginal,
  SELECTED_MODE_VALUES.optimizedVsRebalanced,
] as const

export const END_VS_START_MODES = [
  SELECTED_MODE_VALUES.endVsStart,
  SELECTED_MODE_VALUES.rebalancedVsEnd,
  SELECTED_MODE_VALUES.rebalancedVsStart,
] as const
